import styled from "styled-components";

const InputContainer = styled.div`
  margin-bottom: 30px;
`;

export default InputContainer;
